import { FC } from 'react';

import styles from './DistrictsModalHeader.css';

export const DistrictsModalHeader: FC = () => {
  return <div className={styles['container']}>Выберите район</div>;
};

DistrictsModalHeader.displayName = 'DistrictsModalHeader';
